exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".openCardListTile[data-v-7b3409f6]{height:auto;white-space:normal;overflow:visible}", ""]);

// exports
